"use client";

import { useEffect, useBodyScrollLock } from "@/ui";
import { motion, AnimatePresence } from "motion/react";
import clsx from "clsx";


export function Modal(props: {
  onClose: () => void;
  children?: React.ReactNode;
  className?: string;
  noBackgroundDim?: boolean;
  fullScreen?: boolean;
}) {
  const isOpen = !!props.children;

  useBodyScrollLock(isOpen);

  useEffect([isOpen, props.onClose, props.fullScreen], () => {
    const handleKeyDown = (ev: KeyboardEvent) => {
      if (ev.key === "Escape") {
        props.onClose();
      }
    };

    if (isOpen && !props.fullScreen) {
      window.addEventListener("keydown", handleKeyDown);

      return () => {
        window.removeEventListener("keydown", handleKeyDown);
      };
    }
  });

  const dimBackground = (
    !props.fullScreen && props.noBackgroundDim !== true
  );

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          // Overlay
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: props.fullScreen ? 0.4 : 0.2 } }}
          onClick={props.onClose}
          transition={{ duration: 0.2, ease: "easeOut" }}
          className={clsx(
            "fixed inset-0 z-50 flex items-center justify-center p-4",
            dimBackground && "bg-black/50",
          )}
        >
          <motion.div
            className={props.className}
            initial={{
              opacity: 0,
              y: props.fullScreen ? "100%" : 30,
            }}
            animate={{
              opacity: 1,
              y: 0,
              scale: 1,
              transition: {
                duration: props.fullScreen ? 0.30 : 0.20,
                type: props.fullScreen ? "tween" : "spring",
                damping: 10,
                stiffness: 300,
                mass: 0.5
              }
            }}
            exit={{
              opacity: 50,
              y: props.fullScreen ? "100%" : 20,
              transition: { duration: props.fullScreen ? 0.3 : 0.15 }
            }}
            onClick={ev => ev.stopPropagation()}
          >
            {props.children}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
